import { InjectionToken } from '@angular/core';
import { GraphNodeBuilder } from './model/graph-builder.types';

/**
 * Multi token for providing `GraphNodeBuilder`s for declarative forms
 */
export const GRAPH_NODE_BUILDER_TOKEN = new InjectionToken<GraphNodeBuilder[]>(
  'DECLARATIVE_FORMS.GRAPH_NODE_BUILDER',
);
